import React, { useEffect, useRef, useState } from 'react';
import { Box, IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';

const MusicPlayer = ({ tabIndex }) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(null);

  const waterMusic = '/music/nowater.mp3'; // Путь к файлу с музыкой для воды
  const lightMusic = '/music/noelectricity.mp3'; // Путь к файлу с музыкой для света

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.pause();
      if (isPlaying) {
        audioRef.current.src = tabIndex === 0 ? waterMusic : lightMusic;
        audioRef.current.currentTime = 0;
        audioRef.current.play().catch(error => {
          console.log('Autoplay was prevented:', error);
        });
      }
    }
  }, [tabIndex, isPlaying]);

  const toggleMusic = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play().catch(error => {
        console.log('Play was prevented:', error);
      });
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <Box>
      <audio ref={audioRef} loop />
      <IconButton onClick={toggleMusic} color="primary">
        {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
      </IconButton>
    </Box>
  );
};

export default MusicPlayer;
